import { XIcon } from "@heroicons/react/outline";

import { Button } from "../ui/button";
import { OverflowDisplayTooltip } from "../ui/Tooltip/OverflowDisplayTooltip";
import { getEntityColor } from "../UnifiedRegistry/utils";

import { EntityType } from "@/queries";
import { cn } from "@/lib/utils";
import { EntityIcon } from "@/components/ui/icons";

interface MiniEntityItemProps {
  type: EntityType;
  name: string;
  version_number?: number;
  label?: string;
  onRemove?: () => void;
}

const MiniEntityItem = ({ type, name, version_number, label, onRemove }: MiniEntityItemProps) => {
  const hasVersionOrLabel = version_number || label;

  return (
    <div className="inline-flex max-w-full items-center gap-1 rounded-md border border-gray-300 bg-white px-2 py-1">
      <div className={cn("flex-shrink-0 rounded-full p-2", getEntityColor(type))}>
        <EntityIcon type={type} size="xs" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <OverflowDisplayTooltip content={name}>
          <span className="truncate text-xs font-medium">{name}</span>
        </OverflowDisplayTooltip>
        {hasVersionOrLabel && (
          <div className="flex items-center gap-1">
            {version_number && (
              <span className="rounded bg-gray-100 px-1 py-0.5 text-[10px] font-medium text-gray-700">
                Version {version_number}
              </span>
            )}
            {label && (
              <span className="rounded-sm border border-gray-400 bg-white px-1 py-0.5 text-[10px] font-medium text-black">
                {label}
              </span>
            )}
          </div>
        )}
      </div>
      {onRemove && (
        <Button
          onClick={onRemove}
          variant="ghost"
          size="tinyIcon"
          className="ml-1 flex-shrink-0"
          aria-label="Remove"
        >
          <XIcon className="h-3 w-3 text-gray-500" />
        </Button>
      )}
    </div>
  );
};

export default MiniEntityItem;
